module.exports = "<pending-bookings-page></pending-bookings-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/pendingBookings.html
// module id = 2263
// module chunks = 0